import { connect } from "react-redux";
import Heatmap from "../../../../components/heatMap/heatMap";
import { actionCreators } from "../redux/sagas/utilization/utilization";

function reOrderDays(series) {
  const clonedSeries = series.slice(0);

  return clonedSeries.map((item) => {
    // move sunday to the last element of the array to match the column order
    if (item.data[0].toolTipData.includes("Sunday")) {
      item.data.push(item.data.shift());
    }

    return item;
  });
}

export default connect(
  (state) => {
    const showUtilizationPrevPeriod = state.utilization.showUtilizationPrevPeriod;
    const { sourceType } = state.utilization.modalTableData;
    const groupByWeekDay = state.utilization.groupByWeekDay;
    const averageIsSelected = state.utilization.average !== "Not selected";

    return {
      heatMapRadius: 15,
      stroke: 0.5,
      toolTipWidth: averageIsSelected && groupByWeekDay ? 190 : 150,
      toolTipOffset: 120,
      series: reOrderDays(state.utilization.series),
      tableDataLoading: state.utilization.tableDataLoading,
      modalTableData: {
        nestedRows: sourceType !== "marianatek",
        ...state.utilization.modalTableData
      },
      tableHeight: showUtilizationPrevPeriod ? 300 : 320,
      displayAsBubbles: false,
      filledBubbles: true,
      selectedCategory: state.utilization.selectedCategoryFilters.name,
      modalProps: {
        progressInPercent: true,
        showAverageRevenue: true,
        showTotalClasses: true,
        showNumberOfClients: true,
        showPrevPeriod: showUtilizationPrevPeriod,
        mainMetricTitle: "Utilization",
        detailsTitle: "Class Details",
        averageTooltip: state.utilization.averageTooltip
      }
    };
  },
  {
    handleDataClick: (tableDataUid) => {
      let data = {
        tableDataUid: tableDataUid
      };
      return actionCreators.getTableData(data);
    }
  }
)(Heatmap);
